import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import Succes from "../../assets/img/Succes.svg";
import { useDispatch } from "react-redux";
import { closeSkipTribeModal } from "../../redux/Reducers/modalReducer";

const SkipTribeModal = (props) => {
  const dispatch = useDispatch();
  const handleContinue = () => {
    dispatch(closeSkipTribeModal());
  };

  return (
    <>
      <Modal
        {...props}
        className="sign_in_modal categories_modal fillter_categories_modal request_successfully_modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <div className="reportsuccessfully_cntnt">
            <div className="reportsuccessfully_txt">
              <h2>
                You chose to
                <br />
                skip this tribe
              </h2>
              <br />
              <p>
                Don't worry, you can always join a new tribe and tailor your{" "}
                <br />
                preferences to find your people.
              </p>

              <p className="text-white cursor-pointer" style={{ textDecoration: "underline" }}>
                Join new tribe
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="completeyour_profile_btn profile_photo_btn m-0 d-flex">
            <Button
              variant="primary"
              className="btn_blue_large is_btn_active"
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SkipTribeModal;
